var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.375 3.33331H8.625C7.18125 3.33331 6 4.51456 6 5.95831V25.2083C6 26.6521 7.18125 27.8333 8.625 27.8333H20.175C23.9375 27.8333 27 24.7708 27 21.0083V5.95831C27 4.51456 25.8188 3.33331 24.375 3.33331ZM25.25 21.0083C25.25 23.8083 22.975 26.0833 20.175 26.0833H8.625C8.14375 26.0833 7.75 25.6896 7.75 25.2083V5.95831C7.75 5.47706 8.14375 5.08331 8.625 5.08331H24.375C24.8563 5.08331 25.25 5.47706 25.25 5.95831V21.0083Z",
    fill: "#00FF3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.25 14.7083H21.75V16.4583H11.25V14.7083Z",
    fill: "#00FF3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.25 11.2083H21.75V12.9583H11.25V11.2083Z",
    fill: "#00FF3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.25 18.2083H19.125V19.9583H11.25V18.2083Z",
    fill: "#00FF3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.fed5fab7d1cc863a34e94ba9629a9ffb.svg";
export { ForwardRef as ReactComponent };